import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useMutation } from "./maintenance-mutation";
import { apiRequest } from "@/lib/queryClient";
import { useAuth } from "@/lib/auth";
import type { Catalogue, CataloguePreview } from "./catalogue-types";

export function useCatalogue(){
 const {user,currentWorkspace}=useAuth(),client=useQueryClient();
 const query=useQuery<Catalogue>({queryKey:["/api/maintenance/catalogue",currentWorkspace?.id],enabled:!!user&&!!currentWorkspace?.id,queryFn:async()=>(await apiRequest("GET","/api/maintenance/catalogue")).json()});
 const refresh=()=>client.invalidateQueries({predicate:q=>q.queryKey.some(key=>typeof key==="string"&&key.startsWith("/api/maintenance"))});
 const write=useMutation<unknown,Error,{path:string;body:unknown;method?:"POST"|"PATCH";create?:boolean}>({mutationFn:async({path,body,method="POST",create})=>{
  if(!(create?query.data?.canCreate:query.data?.canManage))throw new Error("Permission denied.");
  return (await apiRequest(method,`/api/maintenance/catalogue${path}`,body)).json();
 },onSuccess:refresh});
 const preview=useMutation<CataloguePreview,Error,{path?:string;body:unknown}>({mutationFn:async({path="/preview",body})=>{
  if(!query.data?.canManage)throw new Error("Permission denied.");
  return (await apiRequest("POST",`/api/maintenance/catalogue${path}`,body)).json();
 }});
 return {...query,write,preview};
}
export type CatalogueResource=ReturnType<typeof useCatalogue>;
